module.exports = __webpack_public_path__ + "img/service_img3.c5e1e23c.png";